<template>
  <el-drawer :before-close="closeDrawer" :visible.sync="showFlag" direction="rtl" custom-class="demo-drawer" size="53%" ref="drawer" :with-header="false" destroyOnClose destroy-on-close>
    <div class="drawer-body">
      <h-module-head slot="title" :titleInfo="drawerInfo.titleInfo" :showBar='false' heightPx="80" titleSize='24px' iconEl="el-icon-close" borderB='1px solid #EFEFEF' @clickEvent="closeDrawer"></h-module-head>
      <div class="drawer-content-info" v-loading='isLoading'>
        <template v-for="(item,i) in drawerShowData">
          <div class="drawer-contentItems-body" :key="i">
            <div class="drawer-info-title">
              <div class="title-divider title-divider-color"></div>
              <div class="title-name">{{item.label}}</div>
            </div>
            <div class="form-frame" :style="item.value.length==0?'border-top: 0;':''" v-if="item.objectType == 'show'">
              <h-form-frame-single v-for="(info,n) in item.value" :key="n" :moduleWidth="countWidth(n,item,'module')" :leftWidth="countWidth(n,item,'left')">
                <template v-slot:leftInfo>
                  {{info.label}}
                </template>
                <template v-slot:rightInfo>
                  <template v-if="info.dataType == 'text'">
                    {{info.value}}
                  </template>
                  <template v-else v-for="(url,l) in info.value">
                    <el-image :key="l" style="width: 70px; height: 70px;margin-right: 5px;" :src='url' :preview-src-list="info.value">
                    </el-image>
                  </template>
                </template>
              </h-form-frame-single>
            </div>
            <template v-if="item.objectType == 'input'">
              <div class="drawer-info-tem" :key="i" v-for="(item,i) in item.value">
                <div class="item-title">{{item.itemName + ':'}}</div>
                <div class="item-single-choice" v-if="item.itemTypeName == 'SINGLE_CHOICE'">
                  <el-radio-group v-model="submitObj[item.key]" :disabled="!submitBut">
                    <template v-for="(info,n) in item.options">
                      <el-radio :key="n" :label="info.id">{{info.optionName}}</el-radio>
                    </template>
                  </el-radio-group>
                </div>
                <div class="item-multi-select" v-if="item.itemTypeName == 'MULTI_SELECT'">
                  <el-checkbox-group v-model="submitObj[item.key]" :disabled="!submitBut">
                    <el-checkbox v-for="(info,n) in item.options" :key="n" :label="info.id">{{info.optionName}}</el-checkbox>
                  </el-checkbox-group>
                  <!-- <div v-for="(info,n) in item.options" :key="n">{{info.optionName}}</div> -->
                </div>
                <div class="item-multiple-input" v-if="item.itemTypeName == 'MULTIPLE_INPUT'">
                  <el-input v-model="submitObj[item.key]" type="textarea" :disabled="!submitBut" :show-word-limit='item.maxlength?true:false' :maxlength='item.length?item.length:300' :placeholder="item.itemPlaceholder?item.itemPlaceholder:'请输入内容'" :rows="item.rowsLimit?item.rowsLimit:5"></el-input>
                </div>
                <div class="item-single-input" v-if="item.itemTypeName == 'SINGLE_INPUT'">
                  <el-input v-model="submitObj[item.key]" placeholder="请输入内容" :disabled="!submitBut"></el-input>
                </div>
                <div class="item-photo" v-if="item.itemTypeName == 'PHOTO'">
                  <div class="item-photo-upload-show" v-if="item.picMaxNum">
                    <div v-for="(pic,n) in submitObj[item.key]" :key="n" style="border: 0; margin: 0 20px 20px 0">
                      <el-image :src="pic" style="width: 100%; height: 100%" alt="" :preview-src-list="submitObj[item.key]"></el-image>
                      <i :key="n" class="el-icon-error clearImg" v-if="submitBut" @click="clearImg(item,n)"></i>
                    </div>
                    <div v-if="submitObj[item.key].length < item.picMaxNum && submitBut" style="margin: 0 20px 20px 0">
                      <img src="https://oss.hebooming.com/icsp/warehouse/image/29dd956b5e5aa1482d4264bae9da4945.png" alt="" />
                      <input class="item-photo-upload-input" type="file" @change="addImg($event, item)" ref="fdyywjxsjythjld" multiple accept="image/png,image/jpeg,image/gif,image/jpg" />
                    </div>
                  </div>

                  <div class="downloadTemplate" v-if="item.itemSrc" @click="downloadTemplate(item)">
                    <i class="el-icon-upload" style="font-size: 28px"></i>
                    <div>下载附件</div>
                  </div>
                </div>
              </div>
            </template>

          </div>
        </template>

      </div>
      <div class="bottom-button-modul" style="margin: 0;" v-if="submitBut">
        <button class="bottom-cancel-button" style="margin-right: 16px;" @click="closeDrawer">取消</button>
        <button class="bottom-sure-button" @click="submit">确定</button>
      </div>
    </div>

  </el-drawer>
</template>

<script>
/*
抽屉的基本信息
drawerInfo:{
    titleInfo: '编辑档案',//抽屉标题
    submitBut: true,//是否需要抽屉底部按钮
    apiName: {
      submit: 'saveGraduateMail',//接口名
    }, //接口API的名
    conditions: {
      //提交使用的条件
      submit: {
        id: '',
        studentNo: '',
      },//按使用地方区分
      dealDataFun:function(){},//处理提交数据的函数
      submitCheck:true,//提交是否校验
      submitCheckFun:function(){}//返回校验状态及报错内容
    }, //接口需要的字段
}
//抽屉展示的数据，分展示模块和输入模块，后续还可以加入流程模块或其他
drawerShowData:{
    {
      label: '学生信息',//标题名
      value: [
        {
          label: '姓名',
          value: '张三',
          dataType: 'text',//文字内容
        },
        {
          label: '姓名',
          value: ['https://.......img.png'],
          dataType: 'img',//图片内容（图片要放到数组最后一位，若有多张图片请处理到一起）
        },
        
      ],//表格内容
      imgTag:true,//是否有图片
      objectType: 'show',//表格展示
    },
    {
      label: '审批信息',//标题名
      value: [
        {
          itemName: '单号',//输入内容的名字
          itemValue: res.data[key] ? res.data[key].mailNo : '',//默认值（若是图片，默认值为数组）
          itemTypeName: 'SINGLE_INPUT',//输入的类型：SINGLE_INPUT、SINGLE_CHOICE、MULTI_SELECT、MULTIPLE_INPUT、PHOTO（只测试及使用了SINGLE_INPUT和PHOTO，其他的后续使用者测试）
          key: 'mailNo',//接口需要的key
          options:[],//select、checkbox需要
          picMaxNum:3,//若是图片则需要填写上传图片数量
          //value的属性按实际情况自行扩展
        },
      ],//表格内容
      objectType: 'input',//需要用户输入
    },
}


*/
import hModuleHead from './h-module-head.vue'
export default {
  components: { hModuleHead },
  props: {
    showFlag: {
      type: Boolean,
      default: false,
    },
    drawerInfo: {
      type: Object,
      default: () => {
        return {}
      },
    },
    drawerShowData: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data: () => {
    return {
      isLoading: false,
      submitObj: {},
      submitBut: true,
    }
  },
  watch: {
    //若是有需要用户输入的字段且有初始值则赋值
    showFlag(val) {
      if (val) {
        this.submitBut = this.drawerInfo.submitBut
        for (const item of this.drawerShowData) {
          if (item.objectType == 'input') {
            for (const info of item.value) {
              if (info.itemValue) {
                this.$set(this.submitObj, info.key, info.itemValue)
              }
            }
          }
        }
        console.log('this.submitObj:', this.submitObj)
      }
    },
  },
  computed: {},
  methods: {
    addImg(event, item) {
      let data = {}
      data.file = event.target.files[0]
      this.$API.ImageUpload(data).then(
        (res) => {
          console.log('图片信息', res)
          let arr = this.submitObj[item.key]
          arr.push(res)
          this.$set(this.submitObj, item.key, arr)
          console.log('this.submitOb', this.submitOb)
        },
        (err) => {
          console.log('上传图片返回的数据失败：', err)
        }
      )
    },
    // 清除图片
    clearImg(item, index) {
      this.submitObj[item.key].splice(index, 1)
    },
    downloadTemplate(item) {
      let doc_url = JSON.parse(item.itemSrc).doc_url
      // window.location.href = doc_url
      window.open(`${doc_url}`, '_blank')
    },
    countWidth(index, data, type) {
      let persent = function (flag, types) {
        if (flag) {
          if (types == 'module') {
            return '100%'
          } else {
            return '15%'
          }
        } else {
          if (types == 'module') {
            return '50%'
          } else {
            return '30%'
          }
        }
      }
      if (data.imgTag) {
        let imgIndex = data.value.findIndex(function (item) {
          return item.dataType == 'img'
        })
        if (data.value.length % 2 == 0) {
          if (index == imgIndex - 1 || index >= imgIndex) {
            return persent(true, type)
          } else {
            return persent(false, type)
          }
        } else {
          if (index >= imgIndex) {
            return persent(true, type)
          } else {
            return persent(false, type)
          }
        }
      } else {
        if (data.value.length % 2 == 1 && index == data.value.length - 1) {
          return persent(true, type)
        } else {
          return persent(false, type)
        }
      }
    },
    submit() {
      let data = {}
      if (this.drawerInfo.conditions && this.drawerInfo.conditions.submitCheck) {
        let checkObj = this.drawerInfo.conditions.submitCheckFun(this.submitObj)
        if (checkObj.flag) {
          this.$message({
            message: checkObj.message,
            type: 'error',
          })
          return
        }
      }
      for (const key in this.submitObj) {
        data[key] = this.submitObj[key]
      }
      if (this.drawerInfo.conditions && this.drawerInfo.conditions.dealDataFun) {
        data = this.drawerInfo.conditions.dealDataFun(data)
      }
      if (this.drawerInfo.conditions && this.drawerInfo.conditions.submit) {
        for (const key in this.drawerInfo.conditions.submit) {
          data[key] = this.drawerInfo.conditions.submit[key]
        }
      }
      this.$API[this.drawerInfo.apiName.submit](data).then((res) => {
        if (res.code == '10000') {
          this.$message({
            message: '提交成功！',
            type: 'success',
          })
          this.closeDrawer()
        } else {
          this.$message({
            message: res.message,
            type: 'error',
          })
        }
      })
    },
    closeDrawer() {
      this.submitObj = {}
      this.$emit('close')
    },
  },
}
</script>

<style lang="less" scoped>
.displayFlex {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.drawer-body {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;

  .drawer-content-info {
    padding: 20px 60px 40px 60px;
    height: calc(100vh - 166px);
    .displayFlex;
    flex-direction: column;
    justify-content: flex-start;
    width: 100%;
    overflow-y: auto;

    .drawer-contentItems-body {
      width: 100%;
      // height: 100%;
      margin-bottom: 20px;
      .drawer-info-title {
        .displayFlex;
        position: relative;
        height: 58px;
        width: 100%;
        background: #ffffff;
        .title-divider {
          left: 0;
        }

        .title-name {
          position: absolute;
          left: 12px;
          font-size: 20px;
          font-family: PingFang SC;
          font-weight: 600;
          color: #2b2f3f;
        }

        .download-btn {
          position: absolute;
          right: 1px;
        }
      }
      .drawer-info-tem {
        .displayFlex;
        justify-content: flex-start;
        align-items: flex-start;
        min-height: 70px;
        font-size: 16px;
        color: #999999;
        padding-top: 20px;
        .item-title {
          width: 130px;
          text-align: start;
        }

        .item-single-choice {
          flex: 1;
          .displayFlex;
          justify-content: flex-start;
          padding-top: 4px;
          .el-radio-group {
            line-height: 25px;
          }
        }

        .item-multi-select {
          flex: 1;
          .displayFlex;
          justify-content: flex-start;
          padding-top: 4px;
          .el-checkbox-group {
            line-height: 25px;
          }
        }

        .item-multiple-input {
          flex: 1;
          .displayFlex;
          justify-content: flex-start;
          padding-top: 4px;
          .el-textarea {
            line-height: 25px;
            width: 500px;
          }
        }

        .item-single-select {
          flex: 1;
          .displayFlex;
          justify-content: flex-start;
          padding-top: 4px;
          .el-select {
            line-height: 25px;
            width: 500px;
          }
        }

        .item-single-input {
          width: 500px;
        }

        .item-photo {
          display: flex;
          flex-flow: wrap;
          flex: 1;
          .item-photo-upload-show {
            width: auto;
            height: 120px;
            background-color: #fdfdfd;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            flex-flow: wrap;
            & > div {
              width: 100px;
              height: 100px;
              border: 1px dashed #d0d0d0;
              background-color: #fdfdfd;
              display: flex;
              justify-content: center;
              align-items: center;
              position: relative;
              .clearImg {
                position: absolute;
                top: -8px;
                right: -8px;
                color: #17A48B;
                font-size: 24px;
              }
              .item-photo-upload-input {
                position: absolute;
                width: 100%;
                height: 100%;
                opacity: 0;
              }
            }
            //   .item-photo-upload {
            //     width: 100px;
            //     height: 100px;
            //     border: 1px dashed #d0d0d0;
            //     background-color: #fdfdfd;
            //     display: flex;
            //     justify-content: center;
            //     align-items: center;
            //     position: relative;
            //     .item-photo-upload-input {
            //       position: absolute;
            //       width: 100%;
            //       height: 100%;
            //       opacity: 0;
            //     }
            //   }
          }

          .downloadTemplate {
            color: #20b2eb;
            font-size: 18px;
            display: flex;
            align-items: flex-end;
            height: 100px;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/parts/h-details-drawer.vue